enum PurchaseOrderStatus {
  CREATED = "CREATED",
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED",
  EXECUTION_COMPLETED = "EXECUTION_COMPLETED",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED"
}

export const RefundApplicableStatus: Array<PurchaseOrderStatus> = [
  PurchaseOrderStatus.COMPLETED,
  PurchaseOrderStatus.PAYMENT_COMPLETED
];

export const ReceiptApplicableStatus: Array<PurchaseOrderStatus> = [
  PurchaseOrderStatus.COMPLETED,
  PurchaseOrderStatus.PAYMENT_COMPLETED
];

export const InvoiceApplicableStatus: Array<PurchaseOrderStatus> = [PurchaseOrderStatus.CREATED];

export default PurchaseOrderStatus;
